import Api from '@services/api'

import type { HubspotEventPayload } from './types'
import { API_HUBSPOT_EVENT_URL } from './urls'

export function sendHubspotEvent(payload: HubspotEventPayload) {
  return Api.post(API_HUBSPOT_EVENT_URL, payload)
}
